import { PlatformSelectionTable } from '@/routes/AudiencePage/charts/PlatformSelectionTable';
import { Column, TableCell } from '@/components/Table';
import { GenderPlaysResponse, SelectedPlatform, GenderData } from '@/types/api/gender';
import { sortByPlatformDisplayOrder } from '@/utils/platformUtils';
import { uppercaseFirstLetter } from '@/utils';
import { formatPercentage } from '@/utils/numberFormattingUtils';

export const GenderDataByPlatform = ({
  data,
  selectedPlatform,
  handlePlatformChange,
}: {
  data: GenderPlaysResponse;
  selectedPlatform: SelectedPlatform<typeof data>;
  handlePlatformChange: (platform: SelectedPlatform<typeof data>) => void;
}) => {
  const getHighestValueLabel = (data: GenderData[]) => {
    const highestValueObject = [...data].sort((a, b) => b.value - a.value)[0];
    return (
      <>
        <span className="text-textDarkGrey font-normal">
          {/* TODO: format this in the API or in a helper function? */}
          {uppercaseFirstLetter(highestValueObject.label.toLowerCase())}
        </span>{' '}
        <span className="text-textMedGrey font-light text-sm ml-1">
          {/* TODO: format this in the API or in a helper function? */}
          {formatPercentage(highestValueObject.percentage)}%
        </span>
      </>
    );
  };

  const tableColumns: Column[] = [
    { key: 'radio', header: '', align: 'left' },
    { key: 'platform', header: 'Platform', className: 'p-2' },
    { key: 'top_gender', header: 'Top gender', align: 'right', className: 'p-2' },
  ];

  return (
    <div className="max-w-full">
      <PlatformSelectionTable<GenderPlaysResponse, GenderPlaysResponse['plays'][number]>
        idPrefix="gender-data"
        data={sortByPlatformDisplayOrder(data)}
        selectedPlatform={selectedPlatform}
        handlePlatformChange={handlePlatformChange}
        tableColumns={tableColumns}
        renderDataCells={(rowData: GenderPlaysResponse['plays'][number]) => (
          <TableCell align="right" className="px-2">
            {getHighestValueLabel(rowData.gender_distribution)}
          </TableCell>
        )}
      />
    </div>
  );
};
